export const WHATSAPP_LINK = "https://wa.me/6597699414";

export const EMAIL_LINK = "mailto:bhmata@sph.com.sg";

export const TERMS_AND_CONDITIONS_LINK =
  "https://www.sph.com.sg/legal/website_tnc/";

export const PRIVACY_POLICY_LINK = "https://www.sph.com.sg/legal/sph_privacy/";

export const EMAIL_SUBJECT = encodeURIComponent("Berita Harian's netizen news");

export const EMAIL_BODY = encodeURIComponent(`
Thank you for sharing your news story.

By sending in your contribution, you grant SPH Media (as defined in the SPH Website Terms and Conditions) a non-exclusive, worldwide, perpetual, irrevocable, sub licensable, royalty-free licence to the full copyright in your contribution, in any media/medium, with respect to your contribution; and you irrevocably and unconditionally waive for the benefit of SPH Media all moral rights (and such similar rights) which may arise at any time in Singapore and worldwide, in relation to your contribution. You also represent and warrant that your contribution is your own original work and will not expose SPH Media to any legal liabilities.

Please ensure you include the following details in the email body above:
1. The title of your entry
2. Date time, location and details of the incident.
3. Original photos or videos of the incident.
4. Your name
5. Your contact number (we will need to call you to get more information)
`);
